import { usePagination, useSorting } from "@/hooks";
import { GetPayoutHistoryParams } from "@/redux/apis/payment/record/types";

export const useGetPayoutHistoryParams = () => {
  const { page, pageSize } = usePagination();
  const { sortKey, direction } = useSorting();

  const params: GetPayoutHistoryParams = {
    page,
    page_size: pageSize,
    sort: sortKey,
    direction,
  };

  return { params, page, pageSize, sort: sortKey, direction };
};
